// dependencies
import { Map, fromJS } from "immutable";
import moment from "moment";

// selectors
import { getJobs } from "../selectors/jobs";

const baseAction = "JOBS";

export function UpdateJobs(jobs) {
	return (dispatch, getState) => {
		const currentState = getState();
		const currentJobsHash =
			currentState.jobs.get("jobs").size > 0 ? currentState.jobs.get("jobs").hashCode() : null;
		const newJobsHash = fromJS(jobs).hashCode();

		if (currentState.jobs.get("receivedFirstResponse") === false) {
			dispatch({ type: `${baseAction}:FIRSTRESPONSE`, noPrint: true });
		}

		// only update our state if the jobs have changed
		if (currentJobsHash !== newJobsHash) {
			dispatch({ type: `${baseAction}:UPDATE`, jobs, noPrint: true });
		}
	};
}

/**
 * Creates a fake job. Useful if we an async job is possibly to quick and won't
 * up in the UI but is important to the user's experience.
 *
 * @param {String} name - name of the job
 * @param {String} title - title to give the job
 */
export const createImitationJob =
	(name = "", title = `name: ${name}`) =>
	(dispatch, getState) => {
		const state = getState();
		let jobs = getJobs(state);

		const imitationJob = Map({
			name,
			title,
			started: true,
			finished: false,
			task_id: moment().unix(),
			errors: [],
			type: null,
			has_progress: null,
			progress_count: 0,
			progress_total: 100,
		});

		jobs = jobs.push(imitationJob);

		dispatch({ type: `${baseAction}:UPDATE`, jobs });
	};
